<div class="filter-row">
  <div class="filter-left">

    <button class="btn btn-default btn-sm" type="button" (click)="badge('0')" [ngClass]="{active: q('0')}">
      Bestellt
    </button>

    <button class="btn btn-info btn-sm" type="button" (click)="badge('1')" [ngClass]="{active: q('1')}">
      Bestätigt
    </button>

    <button class="btn btn-warning btn-sm" type="button" (click)="badge('2')" [ngClass]="{active: q('2')}">
      Versand China
    </button>

    <button class="btn btn-primary btn-sm" type="button" (click)="badge('3')" [ngClass]="{active: q('3')}">
      Empfangen
    </button>

    <button class="btn btn-purple btn-sm" type="button" (click)="badge('4')" [ngClass]="{active: q('4')}">
      Geprüft
    </button>

    <button class="btn btn-success btn-sm" type="button" (click)="badge('5')" [ngClass]="{active: q('5')}">
      Gebucht
    </button>

    <button class="btn btn-danger btn-sm" type="button"
      (click)="badge('true', 'cfa', true)"
      [ngClass]="{active: q('true', 'cfa')}">
      Handlungsbedarf
    </button>

    <button class="btn btn-danger btn-sm" type="button"
      (click)="badge('true', 'price_not_confirmed', true)"
      [ngClass]="{active: q('true', 'price_not_confirmed')}">
      Preis nicht Bestätigt
    </button>

    @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
      <button class="btn btn-default btn-sm" type="button" (click)="badge('all')"
        [ngClass]="{active: q('all')}">
        Alle
      </button>
    }

    <button class="btn btn-danger btn-sm" type="button" (click)="badge('101')" [ngClass]="{active: q('101')}">
      Gelöscht
    </button>

    @if (('order.export'|HasPerm)) {
      <button type="button" class="btn btn-sm btn-default" (click)="excelDownload()">
        Export
      </button>
    }

    <div style="padding-left: 20px; display: inline-block;">
      <button class="btn btn-link btn-default default-gray"
        type="button"
        title="DHL Express"
        [ngClass]="{'active': q2.delivery_method === 'DHL Express'}"
        (click)="badgeToggle('delivery_method', 'DHL Express')">
        <i class="fa fa-truck"></i>
      </button>
      <button class="btn btn-link btn-default default-gray"
        type="button"
        title="Flugzeug"
        [ngClass]="{'active': q2.delivery_method === 'Flugzeug'}"
        (click)="badgeToggle('delivery_method', 'Flugzeug')">
        <i class="fa fa-plane"></i>
      </button>
      <button class="btn btn-link btn-default default-gray"
        type="button"
        title="Zug"
        [ngClass]="{'active': q2.delivery_method === 'Zug'}"
        (click)="badgeToggle('delivery_method', 'Zug')">
        <i class="fa fa-train"></i>
      </button>
      <button class="btn btn-link btn-default default-gray"
        type="button"
        title="Schiff"
        [ngClass]="{'active': q2.delivery_method === 'Schiff'}"
        (click)="badgeToggle('delivery_method', 'Schiff')">
        <i class="fa fa-ship"></i>
      </button>
    </div>
    <div class="float-right">
      <div class="row">
        <div class="col-lg-6">
          <label class="control-label" title="Lief.Ter.(ETD)">Liefertermin (ETD):</label>
          <date-range [start]="data['delivery_date_start']"
            [end]="data['delivery_date_end']"
            (update)="updateDeliveryDate($event)">
          </date-range>
        </div>

        <div class="col-lg-6">
          <label class="control-label" title="Vor. Lief.">Voraussichtlicher Liefertermin:</label>
          <date-range [start]="data['delivery_date_estimated_start']"
            [end]="data['delivery_date_estimated_end']"
            (update)="updateDeliveryDateEstimated($event)">
          </date-range>
        </div>
      </div>
    </div>
  </div>
</div>

<form #changeForm="ngForm" name="form">
  <table class="table whitetable">
    <thead>
      <tr>
        <th>
          <a (click)="sort($event, 'workflow_order_id', 'ASC')" [href]="sortUrl('workflow_order_id', 'ASC')">
            Bestellung Nr.
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'workflow_order_date', 'DESC')" [href]="sortUrl('workflow_order_date', 'DESC')">
            Datum
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'workflow_id', 'ASC')"
            [href]="sortUrl('workflow_id', 'ASC')">
            Vorgang
          </a>
        </th>
        <th>
          Prüfung
        </th>

        <th>
          <a (click)="sort($event, 'article_sds_nr', 'ASC')" [href]="sortUrl('article_sds_nr', 'ASC')">
            SDS-Nr.
          </a>
        </th>

        <th>
          <a (click)="sort($event, 'article_oa_nr', 'ASC')" [href]="sortUrl('article_oa_nr', 'ASC')">
            0A-Nr.
          </a>
        </th>

        <th>
          <a (click)="sort($event, 'article_kd_art_nr', 'ASC')" [href]="sortUrl('article_kd_art_nr', 'ASC')">
            Kunden-Art-Nr.
          </a>
        </th>

        <th>
          <a (click)="sort($event, 'workflow_order_producer', 'ASC')" [href]="sortUrl('workflow_order_producer', 'ASC')">
            Produzent
          </a>
        </th>

        <th class="nowrap">
          <a (click)="sort($event, 'workflow_order_delivery_date', 'ASC')"
            [href]="sortUrl('workflow_order_delivery_date', 'ASC')">
            Lief.Ter.(ETD)
          </a>
        </th>

        <th class="nowrap">
          <a (click)="sort($event, 'workflow_order_date_estimated', 'ASC')"
            [href]="sortUrl('workflow_order_date_estimated', 'ASC')">
            Vor.Lief.
          </a>
        </th>

        <th class="nowrap">
          <a (click)="sort($event, 'workflow_fetch_date_delivery', 'ASC')"
            [href]="sortUrl('workflow_fetch_date_delivery', 'ASC')">
            Kd.Lief.
          </a>
        </th>

        <th>
          <a (click)="sort($event, 'workflow_order_request_nr', 'ASC')"
            [href]="sortUrl('workflow_order_request_nr', 'ASC')">
            Anfrage Nr.
          </a>
        </th>

        <th class="align-right">
          <a (click)="sort($event, 'workflow_order_quantity', 'ASC')"
            [href]="sortUrl('workflow_order_quantity', 'ASC')">
            Menge
          </a>
        </th>
        <th class="align-right">
          <a (click)="sort($event,'workflow_order_price', 'ASC')"
            [href]="sortUrl('workflow_order_price', 'ASC')">
            Preis
          </a>
        </th>

        <th>
          <a (click)="sort($event, 'customer_name', 'ASC')" [href]="sortUrl('customer_name', 'ASC')">
            Kunde
          </a>
        </th>

        <th>
          Buch. Nr
        </th>

        <th>
          RG Nr
        </th>

        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
      </tr>

      <tr class="filterrow">
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.sid" name="sid" [autofocus]
            autocomplete="off search-order-request-id">
        </th>
        <th>&nbsp;</th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.workflow_id" name="workflow_id">
        </th>
        <th>
          <select class="form-control input-sm" [(ngModel)]="data.workflow_order_testing" name="testing">
            <option [ngValue]="null">-</option>
            <option value="E-Muster">E-Muster</option>
            <option value="Serie">Serie</option>
            <option value="Serie mit EMPB">Serie mit EMPB</option>
          </select>
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.sds_nr" name="sds_nr">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.oa_nr" name="oa_nr">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.kd_art_nr" name="kd_art_nr">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.producer" name="producer">
        </th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.request_nr" name="request_nr">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.quanity" name="quanity">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.price" name="price">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.customer" name="customer">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.booking_id" name="booking_id">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.supplier_rg_nr" name="supplier_rg_nr">
        </th>

        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      @for (obj of list.objects; track obj; let index = $index) {
        <tr [ngClass]="{'alert-danger': obj.workflow_order_cfa || obj.call_for_action_price}">
          <td>
            @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
              <a
                uiSref="a.workflow.request.detail" [uiParams]="{id: obj.workflow_id}">
                {{ obj.workflow_order_id }}
                <ev-status-label type="order_status" [state]="obj.workflow_order_status"></ev-status-label>
                &nbsp;
                @if (obj.workflow_order_mail_sent) {
                  <i class="fa fa-paper-plane ev-blue-color"
                  title="Bestellung wurde per Mail versendet"></i>
                }
              </a>
            }
            @if (!(('task.view'|HasPerm)||('task.offer.view'|HasPerm))) {
              <div class="content">
                {{ obj.workflow_order_id }}
                <ev-status-label type="order_status" [state]="obj.workflow_order_status"></ev-status-label>
                &nbsp;
                @if (obj.workflow_order_mail_sent) {
                  <i class="fa fa-paper-plane ev-blue-color"
                  title="Bestellung wurde per Mail versendet"></i>
                }
              </div>
            }
          </td>
          <td>{{ obj.workflow_order_date|ZonedDateTime:{showDate: true, showTime: false} }}</td>
          <td class="align-middle! p-0!">
            <div class="grid max-3xl:grid-cols-2 3xl:max-6xl:grid-cols-4 6xl:grid-cols-6 p-0">
              @if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm)) {
                <div class="col-span-2 p-0!">
                  <a uiSref="a.workflow.detail" [uiParams]="{id: obj.workflow_id}">
                    {{ obj.workflow_id }}
                  </a>
                </div>

                <div class="col-span-2">
                  <a uiSref="a.workflow.detail" [uiParams]="{id: obj.workflow_id}">
                    <ev-status-label clazz="m-0!" type="workflow_status" [state]="obj.workflow_status"></ev-status-label>
                  </a>
                </div>

                @if (obj.workflow_fetch_express) {
                  <div>
                    <a uiSref="a.workflow.detail" [uiParams]="{id: obj.workflow_id}">
                      <span class="inline-block fa fa-stack subscript right" ngbTooltip="Eildienst">
                        <i class="fa fa-stack-1x fa-exclamation-triangle"></i>
                        <i class="fa fa-stack-2x fa-truck text-px-12!"></i>
                      </span>
                    </a>
                  </div>
                }
              } @else {
                <div class="col-span-2">
                  {{ obj.workflow_id }}
                </div>
                <div class="col-span-2">
                  <ev-status-label type="workflow_status" [state]="obj.workflow_status"></ev-status-label>
                </div>
              }

              @if (obj.call_for_action_price) {
                <div>
                    <span class="inline-block fa fa-stack subscript right" ngbTooltip="Preis nicht Bestätigt">
                      <i class="fa fa-euro fa-stack-1x text-black"></i>
                      <i class="fa fa-times fa-stack-2x text-storz-red text-px-12!"></i>
                    </span>
                </div>
              }
            </div>
          </td>
          <td>
            <span class="label label-{{ obj.label }}">{{ obj.workflow_order_testing }}</span>
          </td>
          <td>
            {{ obj.article_sds_nr }}
            @if (obj.article_data.special_production) {
              <span class="label label-danger">Spezial</span>
            }
          </td>
          <td>
            <div class="label"
             [ngClass]="{'label-danger': obj.article_hash !== obj.workflow_order_article_hash,
                     'label-success': obj.article_hash === obj.workflow_order_article_hash }">
              {{ obj.article_oa_nr }}
            </div>
          </td>
          <td>{{ obj.article_data.kd_art_nr }} {{ obj.article_data.kd_art_index}}</td>
          <td>
            @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
              <a
                uiSref="a.workflow.request.detail" [uiParams]="{id: obj.workflow_id}">
                {{ obj.workflow_order_producer }}
              </a>
            }
            @if (!(('task.view'|HasPerm)||('task.offer.view'|HasPerm))) {
              <div class="content">
                {{ obj.workflow_order_producer }}
              </div>
            }
          </td>
          <td class="nowrap">
            @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
              <a
                uiSref="a.workflow.request.detail" [uiParams]="{id: obj.workflow_id}">
                {{ obj.workflow_order_delivery_date|ZonedDateTime:{showDate: true, showTime: false} }}
              </a>
            }
            @if (!(('task.view'|HasPerm)||('task.offer.view'|HasPerm))) {
              <div class="content">
                {{ obj.workflow_order_delivery_date|ZonedDateTime:{showDate: true, showTime: false} }}
              </div>
            }
            @for (data of obj.workflow_order_data; track data) {
              <cn-order-delivery-method [spaced]="true" [size17]="true"
                [deliveryMethod]="$safeNavigationMigration(data.confirmed?.delivery_method)"
                >
              </cn-order-delivery-method>
            }
          </td>
          <td>
            <div class="content">
              @for (date of obj.workflow_order_delivery_dates_estimated; track date; let i = $index) {
                {{ date|date:'dd.MM.yyyy' }}
              }
            </div>
          </td>
          <td>
            @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
              <a
                uiSref="a.workflow.detail" [uiParams]="{id: obj.workflow_id}">
                {{ obj.workflow_fetch_date_delivery|date:'dd.MM.yyyy' }}
              </a>
            }
            @if (!(('task.view'|HasPerm)||('task.offer.view'|HasPerm))) {
              <div class="content">
                {{ obj.workflow_fetch_date_delivery|date:'dd.MM.yyyy' }}
              </div>
            }
          </td>
          <td>
            @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
              <a
                uiSref="a.workflow.request.detail" [uiParams]="{id: obj.workflow_id}">
                {{ obj.workflow_order_request_nr }}
              </a>
            }
            @if (!(('task.view'|HasPerm)||('task.offer.view'|HasPerm))) {
              <div class="content">
                {{ obj.workflow_order_request_nr }}
              </div>
            }
          </td>
          <td class="align-right">
            @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
              <a
                uiSref="a.workflow.request.detail" [uiParams]="{id: obj.workflow_id}">
                {{ obj.workflow_order_quantity |money}}
              </a>
            }
            @if (!(('task.view'|HasPerm)||('task.offer.view'|HasPerm))) {
              <div class="content">
                {{ obj.workflow_order_quantity |money}}
              </div>
            }
          </td>
          <td class="align-right">
            @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
              <a
                uiSref="a.workflow.request.detail" [uiParams]="{id: obj.workflow_id}">
                {{ obj.workflow_order_price |money:3}}
              </a>
            }
            @if (!(('task.view'|HasPerm)||('task.offer.view'|HasPerm))) {
              <div class="content">
                {{ obj.workflow_order_price |money:3}}
              </div>
            }
          </td>
          <td>
            <a uiSref="a.crm.customer.detail" [uiParams]="{id:obj.customer_id}">
              {{ obj.customer_name }}
            </a>
          </td>
          <td>
            @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
              <a
                uiSref="a.workflow.request.detail" [uiParams]="{id: obj.workflow_id}">
                {{ obj.booking_ids|Concat }}
              </a>
            }
            @if (!(('task.view'|HasPerm)||('task.offer.view'|HasPerm))) {
              <div class="content">
                {{ obj.booking_ids|Concat }}
              </div>
            }
          </td>
          <td>
            @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
              <a
                uiSref="a.workflow.request.detail" [uiParams]="{id: obj.workflow_id}">
                {{ obj.supplier_rg_nrs|Concat }}
              </a>
            }
            @if (!(('task.view'|HasPerm)||('task.offer.view'|HasPerm))) {
              <div class="content">
                {{ obj.supplier_rg_nrs|Concat }}
              </div>
            }
          </td>
          <td class="icon">
            @if (('task.view'|HasPerm)||('task.offer.view'|HasPerm)) {
              <ev-file-button type="order"
                title="Bestellungs-PDF öffnen"
                [objId]="obj.workflow_order_id"
                >
                <i class="fa fa-file-pdf-o"></i>
              </ev-file-button>
            }
          </td>
          <td class="icon">
            @if ((('task.view'|HasPerm)||('task.offer.view'|HasPerm))&& obj.workflow_order_status < 50) {
              <button class="btn btn-link btn-sm"
                type="button"
                title="CN-Bestellung per Mail versenden"
                (click)="mail(obj.workflow_order_id, obj.workflow_id, obj.workflow_order_producer)">
                <i class="fa fa-envelope"></i>
              </button>
            }
          </td>
          <td class="icon">
            @if (obj.workflow_order_status) {
              <button type="button" class="btn btn-link btn-sm" style="color: red;" (click)="cancel(obj)"
                title="Bestellung stornieren">
                <i class="fa fa-ban"></i>
              </button>
            }
          </td>
          <td class="icon">
            @if (obj.workflow_order_status < 50) {
              <button type="button" class="btn btn-link btn-sm" style="color: red;" (click)="remove(obj)"
                title="Bestellung löschen">
                <i class="fa fa-trash-o"></i>
              </button>
            }
          </td>
          <td>
            @if (obj.workflow_order_status < 50) {
              <button type="button" class="btn btn-default btn-sm" (click)="open(obj)"
                >
                Übersicht
              </button>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</form>

<ev-navigation [page]="list.page" [pages]="list.pages" [query]="query()" (goto)="goto($event)"></ev-navigation>
